import { Link, useParams } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Breadcrumb from "@/components/base/Breadcrumb";
import { newsList } from "@/mocks/news";

export default function NewsDetail() {
  const { id } = useParams();
  const article = newsList.find((n) => n.id === id);

  if (!article) {
    return (
      <Layout>
        <div className="w-full px-4 md:px-8 py-24 flex flex-col items-center text-center">
          <span className="w-16 h-16 rounded-full bg-background-100 text-foreground-400 flex items-center justify-center mb-4">
            <i className="ri-emotion-sad-line text-3xl" />
          </span>
          <h1 className="font-heading text-xl font-bold text-foreground-950">
            未找到该资讯
          </h1>
          <p className="mt-2 text-sm text-foreground-500">文章可能已被移除或链接有误</p>
          <Link
            to="/news"
            className="mt-6 inline-flex items-center gap-2 px-5 h-10 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line" />
            返回资讯列表
          </Link>
        </div>
      </Layout>
    );
  }

  const related = newsList
    .filter((n) => article.relatedIds.includes(n.id))
    .slice(0, 3);
  const fallbackRelated = newsList
    .filter((n) => n.id !== article.id && !article.relatedIds.includes(n.id))
    .slice(0, 3 - related.length);
  const relatedList = [...related, ...fallbackRelated];

  return (
    <Layout>
      <article className="w-full px-4 md:px-8 py-6 md:py-10">
        <div className="max-w-3xl mx-auto">
          <Breadcrumb items={[{ label: "影视资讯", to: "/news" }, { label: article.title }]} />

          <header className="mt-5">
            <div className="flex items-center gap-2 flex-wrap mb-3">
              <span className="px-2.5 py-1 rounded bg-primary-100 text-primary-700 text-xs font-medium">
                {article.tags[0]}
              </span>
              {article.tags.slice(1).map((t) => (
                <span
                  key={t}
                  className="px-2.5 py-1 rounded bg-secondary-100 text-secondary-900 text-xs"
                >
                  {t}
                </span>
              ))}
            </div>
            <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              {article.title}
            </h1>
            <div className="mt-4 flex items-center gap-4 text-sm text-foreground-500 flex-wrap">
              <span className="flex items-center gap-1.5">
                <i className="ri-user-line" />
                {article.author}
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-calendar-line" />
                {article.date}
              </span>
            </div>
          </header>

          <div className="mt-6 w-full aspect-[16/9] rounded-lg overflow-hidden bg-background-200">
            <img
              src={article.cover}
              alt={article.title}
              title={`${article.title} - 爱爱网影视资讯`}
              className="w-full h-full object-cover object-top"
            />
          </div>

          <p className="mt-6 text-base md:text-lg text-foreground-800 leading-relaxed font-medium">
            {article.summary}
          </p>

          <div className="mt-6 space-y-5">
            {article.content.map((para, i) => (
              <p key={i} className="text-sm md:text-base text-foreground-700 leading-loose">
                {para}
              </p>
            ))}
          </div>

          <div className="mt-8 pt-6 border-t border-background-200">
            <Link
              to="/news"
              className="inline-flex items-center gap-2 px-5 h-10 rounded-md border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-left-line" />
              返回资讯列表
            </Link>
          </div>

          {/* 相关文章 */}
          <section className="mt-12">
            <h2 className="font-heading text-xl font-bold text-foreground-950 mb-5 flex items-center gap-2">
              <span className="w-1.5 h-5 rounded-full bg-accent-500" />
              相关文章
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              {relatedList.map((n) => (
                <Link
                  key={n.id}
                  to={`/news/${n.id}`}
                  className="group rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-all cursor-pointer"
                >
                  <div className="w-full aspect-[16/9] overflow-hidden bg-background-200">
                    <img
                      src={n.cover}
                      alt={n.title}
                      title={`${n.title} - 爱爱网影视资讯`}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="p-3">
                    <h3 className="font-heading text-sm font-semibold text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {n.title}
                    </h3>
                    <span className="mt-2 block text-xs text-foreground-400">{n.date}</span>
                  </div>
                </Link>
              ))}
            </div>
          </section>
        </div>
      </article>
    </Layout>
  );
}